import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { recipientsOptions } from './config';
import { deleteDefaultReminder } from './store/default_reminders/actions';
import { pluralize } from 'helpers/formatters/string_formats';
import { getOrderedStages } from 'bundles/apex/helpers/stages';
import { getStageOptions } from './helpers';

export function DefaultRemindersTable({ criticalDateOptions, defaultReminders, deleteDefaultReminder, stagesConfig }) {
  if (!defaultReminders.length) return null;
  const stageOptions = getStageOptions(getOrderedStages(stagesConfig));

  return (
    <table className="table bottom-buffer-lg">
      <thead>
        <tr>
          <th>Critical Date</th>
          <th>Reminder</th>
          <th>Recipients</th>
          <th>Stage</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {defaultReminders.map(reminder => (
          <tr key={reminder.id}>
            <td>{criticalDateOptions.find(option => option.value === reminder.dateReference).label}</td>
            <td className="one-line">{`${pluralize(reminder.modifier, reminder.units)} before`}</td>
            <td>{recipientsOptions.find(option => option.value === reminder.recipients).label}</td>
            <td>{stageOptions.find(option => option.value === (reminder.stage || '')).label}</td>
            <td className="text-right">
              <FontAwesomeIcon
                aria-label={`deleteDefaultReminder-${reminder.id}`}
                className="clickable ml-2"
                icon={faTrashAlt}
                onClick={() => deleteDefaultReminder(reminder)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

DefaultRemindersTable.propTypes = {
  criticalDateOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  defaultReminders: PropTypes.arrayOf(PropTypes.shape({
    dateReference: PropTypes.string.isRequired,
    modifier: PropTypes.number.isRequired,
    path: PropTypes.string.isRequired,
    recipients: PropTypes.string.isRequired,
    stage: PropTypes.string,
    units: PropTypes.string.isRequired,
  })).isRequired,
  deleteDefaultReminder: PropTypes.func.isRequired,
  stagesConfig: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  defaultReminders: state.defaultReminders,
  criticalDateOptions: state.criticalDateOptions,
  stagesConfig: state.dealStagesConfig,
});

const mapDispatchToProps = {
  deleteDefaultReminder,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultRemindersTable);
